<template>
  <div>
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="add_employee">
      <div class="form_input flex" v-for="(field, index) in formField" :key="index">
        <MyTransition myName="up">
          <div class="descript_label" v-if="descript.show && descript.index == index">
            {{ field.descript }}
          </div>
        </MyTransition>
        <!-- 離職時間欄位因離職狀態而打開 -->
        <template v-if="field.val == 'leave_date' && !formInput.status">
          <label>
            {{ field.name }}
            <span class="must" v-if="field.must">*</span>
          </label>
          <!--date-->
          <div class="el_elment">
            <el-date-picker v-model="formInput[field.val]" type="date" :placeholder="field.placeholder"
              value-format="yyyy-MM-dd" popper-class="picker-date"></el-date-picker>
            <div class="date_special">
              <p class="must descript">
                ** 如果上方日期無法選擇，則於下方欄位手動輸入日期
                (格式為:2020-01-01)
              </p>
              <input type="text" class="" v-model.lazy="formInput[field.val]" :placeholder="field.placeholder" />
            </div>
          </div>
        </template>
        <template v-else-if="field.val !== 'leave_date'">
          <label>
            {{ field.name }}
            <span>
              <i class="el-icon-info descript_icon" @mouseover="descriptShow(index)" @mouseout="descriptHide"
                v-if="field.descript"></i>
            </span>
            <span class="must" v-if="field.must">*</span>
          </label>
          <!--select-->
          <div class="el_elment" v-if="field.type == 'select'">
            <el-select v-model="formInput[field.val]" :placeholder="field.placeholder">
              <el-option v-for="item in options[field.val]" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <!--switch-->
          <div v-else-if="field.type == 'switch'">
            <el-switch v-model="formInput[field.val]" :active-text="field.switchText[0]"
              :inactive-text="field.switchText[1]"></el-switch>
          </div>
          <!--date-->
          <div class="el_elment" v-else-if="field.type == 'date'">
            <el-date-picker v-model="formInput[field.val]" type="date" :placeholder="field.placeholder"
              value-format="yyyy-MM-dd" popper-class="picker-date"></el-date-picker>
            <div class="date_special">
              <p class="must descript">
                ** 如果上方日期無法選擇，則於下方欄位手動輸入日期
                (格式為:2020-01-01)
              </p>
              <input type="text" class="" v-model.lazy="formInput[field.val]" :placeholder="field.placeholder" />
            </div>
          </div>
          <!-- radio -->
          <div v-else-if="field.type == 'radio'">
            <el-radio v-model="formInput[field.val]" :label="true">{{
              field.switchText[0]
            }}</el-radio>
            <el-radio v-model="formInput[field.val]" :label="false">{{
              field.switchText[1]
            }}</el-radio>
          </div>
          <!-- input -->
          <div v-else-if="field.type == 'input'">
            <input type="text" class="input_primary" v-model.lazy="formInput[field.val]" />
          </div>
          <div v-else>
            <!-- 判斷布林值但該顯示的對應中文 -->
            <template v-if="field.switchText && formInput[field.val]">
              <template v-if="formInput[field.val]">
                {{ field.switchText[0] }}
              </template>
              <template v-else-if="!formInput[field.val]">
                {{ field.switchText[1] }}
              </template>
            </template>
            <template v-else>{{ formInput[field.val] }}</template>
          </div>
        </template>
      </div>
      <!--=======================上傳檔案========================-->
      <div class="form_input flex">
        <label>
          大頭照
          <span class="must">*</span>
        </label>
        <div class="img_upload">
          <!-- 判斷身份 -->
          <template v-if="this.role == 'vendor'">
            <Div>
              <label for="photo"> <i class="el-icon-plus"></i> 點擊上傳 </label>
            </Div>
            <span class="mark">
              請上傳彩色照片，限制PNG與JPG格式，檔案限制1M，建議長寬：寬125px *
              高162px
            </span>
          </template>
          <div>
            <img v-if="upImg" :src="upImg" />
          </div>
          <input type="file" id="photo" accept="image/*" @change="photoUpload" />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          勞工保險附件
          <span class="must">*</span>
        </label>
        <div class="img_upload">
          <!-- 判斷身份 -->
          <template v-if="this.role == 'vendor'">
            <Div>
              <label for="labor">
                <template v-if="!file.labor">
                  <i class="el-icon-plus"></i> 點擊上傳
                </template>
                <template v-else>
                  {{ file.labor }}
                  <span class="cancel_file" @click.prevent="cancelFile('labor')">
                    <i class="el-icon-error"></i>
                  </span>
                </template>
              </label>
            </Div>
            <span class="mark">限制PDF與JPG格式，檔案限制5M</span>
            <div v-if="file.labor">
              <a :href="`${storage}${file.labor}?${time}`" target="_blank">
                <button class="btn_primary">下載 {{ file.labor }}</button>
              </a>
            </div>
          </template>
          <template v-else>
            <a :href="`${storage}${file.labor}?${time}`" target="_blank">
              <button class="btn_primary">打開 {{ file.labor }}</button>
            </a>
          </template>
          <input type="file" id="labor" @change="laborUpload" />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          身分證正反面
          <span class="must">*</span>
        </label>
        <div class="img_upload">
          <!-- 判斷身份 -->
          <template v-if="this.role == 'vendor'">
            <Div>
              <label for="idCard">
                <template v-if="!file.idCard">
                  <i class="el-icon-plus"></i> 點擊上傳
                </template>
                <template v-else>
                  {{ file.idCard }}
                  <span class="cancel_file" @click.prevent="cancelFile('idCard')">
                    <i class="el-icon-error"></i>
                  </span>
                </template>
              </label>
            </Div>
            <span class="mark">限制PDF與JPG格式，檔案限制5M，外國員工可上傳護照檔案</span>
            <div v-if="file.idCard">
              <a :href="`${storage}${file.idCard}?${time}`" target="_blank">
                <button class="btn_primary">下載 {{ file.idCard }}</button>
              </a>
            </div>
          </template>
          <template v-else>
            <a :href="`${storage}${file.idCard}?${time}`" target="_blank">
              <button class="btn_primary">打開 {{ file.idCard }}</button>
            </a>
          </template>
          <input type="file" id="idCard" @change="idCardUpload" />
        </div>
      </div>
    </div>
    <!--==================其餘說明檔案==================-->
    <template v-if="role == 'vendor'">
      <div class="add_employee">
        <div class="form_input flex">
          <label>承攬商意外險(團體保險)投保證明檢核</label>
          <div class="img_upload">
            <div class="sub_block">
              <div class="descript">
                <ul>
                  <li>※工程類人員，意外保險金額為500萬元。</li>
                  <li>※非工程類人員，意外保險金額為300萬元。</li>
                  <li v-if="false">※若不具勞保證明/身分，其意外保險需提高至500萬。</li>
                  <li>
                    ※投保雇主意外責任險保單者，需於保單備註「發生出險，將全額賠予被保人」並蓋公司大小章。
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub_block">
              <div class="time flex">
                到期日
                <div class="time_el">
                  <el-date-picker v-model="formInput.accident_insurance_expiry_date" type="date" placeholder="年-月-日"
                    value-format="yyyy-MM-dd" popper-class="picker-date"></el-date-picker>
                  <div class="date_special">
                    <p class="must descript">
                      ** 如果上方日期無法選擇，則於下方欄位手動輸入日期
                      (格式為:2020-01-01)
                    </p>
                    <input type="text" class="" v-model.lazy="formInput.accident_insurance_expiry_date"
                      placeholder="年-月-日" />
                  </div>
                </div>
              </div>
              <span class="mark">此次待審投保證明到期日</span>
            </div>
            <Div>
              <label for="insurance">
                <template v-if="!file.insurance">
                  <i class="el-icon-plus"></i> 點擊上傳
                </template>
                <template v-else>
                  {{ file.insurance }}
                  <span class="cancel_file" @click.prevent="cancelFile('insurance')">
                    <i class="el-icon-error"></i>
                  </span>
                </template>
              </label>
            </Div>
            <span class="mark">限制PDF與JPG格式，檔案限制5M</span>
            <input type="file" id="insurance" @change="insuranceUpload" />
            <div v-if="file.insurance">
              <a :href="`${storage}${file.insurance}?${time}`" target="_blank">
                <button class="btn_primary">下載 {{ file.insurance }}</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="add_employee">
        <div class="form_input flex">
          <label>勞工安全衛生教育訓練證明(六小時)檢核</label>
          <div class="img_upload">
            <div class="sub_block">
              <div class="descript">
                ※ 工程類：
                <span class="must">必須上傳</span>
                <ul class="indent">
                  <li>
                    －科學工業園區或勞動部核定之合格訓練機構所核發之職業安全衛生教育訓練結業證書(至少6小時)。（有效日期為三年）
                  </li>
                  <li>
                    －外國人則請該公司提供安全衛生教育6小時以上之訓練證明，並須加蓋公司大小章。
                  </li>
                </ul>
                ※ 駐廠人員：
                <ul class="indent">
                  <li>
                    －平時教育訓練證明(如:簽名記錄和上課照片)，由該公司自行上課，有效期限為3年內。
                  </li>
                </ul>
                ※ 非駐廠人員：以下擇一上傳
                <ul class="indent">
                  <!-- <li>
                    －協議組織施工前會議記錄及每日工具箱會議及危害告知紀錄。
                  </li> -->
                  <li>
                    －請所屬公司提供安全衛生教育6小時以上之訓練證明，並須加蓋公司大小章。
                  </li>
                  <li>
                    －道路危險物品運送人員訓練證明，並有在職教育複訓紀錄。
                  </li>
                  <li>
                    －科學工業園區或勞動部核定之合格訓練機構所核發之職業安全衛生教育訓練結業證書(至少6小時)
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub_block">
              <div class="time flex">
                到期日
                <div class="time_el">
                  <el-date-picker v-model="formInput.training_expiry_date" type="date" placeholder="年-月-日"
                    value-format="yyyy-MM-dd" popper-class="picker-date"></el-date-picker>
                  <div class="date_special">
                    <p class="must descript">
                      ** 如果上方日期無法選擇，則於下方欄位手動輸入日期
                      (格式為:2020-01-01)
                    </p>
                    <input type="text" class="" v-model.lazy="formInput.training_expiry_date" placeholder="年-月-日" />
                  </div>
                </div>
              </div>
              <span class="mark">此次待審投保證明到期日</span>
            </div>
            <Div>
              <label for="traning">
                <template v-if="!file.traning">
                  <i class="el-icon-plus"></i> 點擊上傳
                </template>
                <template v-else>
                  {{ file.traning }}
                  <span class="cancel_file" @click.prevent="cancelFile('traning')">
                    <i class="el-icon-error"></i>
                  </span>
                </template>
              </label>
            </Div>
            <span class="mark">限制PDF與JPG格式，檔案限制5M</span>
            <input type="file" id="traning" @change="traningUpload" />
            <div v-if="file.traning">
              <a :href="`${storage}${file.traning}?${time}`" target="_blank">
                <button class="btn_primary">下載 {{ file.traning }}</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="add_employee">
        <div class="form_input flex">
          <label>承攬商意外險(團體保險)投保證明檢核</label>
          <div class="img_upload">
            <div v-if="file.insurance">
              <a :href="`${storage}${file.insurance}?${time}`" target="_blank">
                <button class="btn_primary">打開 {{ file.insurance }}</button>
              </a>
            </div>
            <div v-else>
              <button class="btn_gray">沒有資料</button>
            </div>
            <span class="mark">限制PDF與JPG格式，檔案限制5M</span>
            <div class="sub_block">
              <div class="time flex">
                到期日
                <div class="time_el">
                  {{ formInput.accident_insurance_expiry_date }}
                </div>
              </div>
              <span class="mark">此次待審投保證明到期日</span>
            </div>
            <div class="sub_block">
              <div class="descript">
                <ul>
                  <li>※工程類人員，意外保險金額為500萬元。</li>
                  <li>※非工程類人員，意外保險金額為300萬元。</li>
                  <li v-if="false">※若不具勞保證明/身分，其意外保險需提高至500萬。</li>
                  <li>
                    ※投保雇主意外責任險保單者，需於保單備註「發生出險，將全額賠予被保人」並蓋公司大小章。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="add_employee">
        <div class="form_input flex">
          <label>勞工安全衛生教育訓練證明(六小時)檢核</label>
          <div class="img_upload">
            <div v-if="file.traning">
              <a :href="`${storage}${file.traning}?${time}`" target="_blank">
                <button class="btn_primary">打開 {{ file.traning }}</button>
              </a>
            </div>
            <div v-else>
              <button class="btn_gray">沒有資料</button>
            </div>
            <span class="mark">限制PDF與JPG格式，檔案限制5M</span>
            <div class="sub_block">
              <div class="time flex">
                到期日
                <div class="time_el">{{ formInput.training_expiry_date }}</div>
              </div>
              <span class="mark">此次待審投保證明到期日</span>
            </div>
            <div class="sub_block">
              <div class="descript">
                ※ 工程類：
                <span class="must">必須上傳</span>
                <ul class="indent">
                  <li>
                    －科學工業園區或勞動部核定之合格訓練機構所核發之職業安全衛生教育訓練結業證書(至少6小時)。（有效日期為三年）
                  </li>
                  <li>
                    －外國人則請該公司提供安全衛生教育6小時以上之訓練證明，並須加蓋公司大小章。
                  </li>
                </ul>
                ※ 駐廠人員：
                <ul class="indent">
                  <li>
                    －平時教育訓練證明(如:簽名記錄和上課照片)，由該公司自行上課，有效期限為3年內。
                  </li>
                </ul>
                ※ 非駐廠人員：以下擇一上傳
                <ul class="indent">
                  <!-- <li>
                    －協議組織施工前會議記錄及每日工具箱會議及危害告知紀錄。
                  </li> -->
                  <li>
                    －請所屬公司提供安全衛生教育6小時以上之訓練證明，並須加蓋公司大小章
                  </li>
                  <li>
                    －道路危險物品運送人員訓練證明，並有在職教育複訓紀錄。
                  </li>
                  <li>
                    －科學工業園區或勞動部核定之合格訓練機構所核發之職業安全衛生教育訓練結業證書(至少6小時)
                  </li>
                </ul>
              </div>
            </div>
            <input type="file" id="traning" @change="traningUpload" />
          </div>
        </div>
      </div>
    </template>
    <!--===============其餘檔案結束======================-->
    <!-- 個資法相關 -->
    <div class="personal_data">
      <el-checkbox v-model="personal_data">因應個人資料保護法及本會個人資料管理規定，當您勾選此選項時，表示您瞭解並同意接受本系統蒐集您的個人資料。</el-checkbox>
    </div>

    <div class="addEmployee_btn flex">
      <div v-if="role == 'vendor'">
        <button class="btn_primary" @click="enter">{{ ButtonText }}</button>
      </div>
      <div v-else-if="role !== 'vendor' &&
        this.role !== 'department' &&
        this.$route.params.userData.code_result
        ">
        <button class="btn_primary" @click="codeEnter">核發合格證</button>
      </div>
      <div>
        <button class="btn_gray" @click="returnBack">返回</button>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.add_employee {
  text-align: left;
  background: #fff;
  border-radius: 10px;
  padding: 30px 20px;
  box-shadow: 5px 5px 20px -12px rgba($color: #000000, $alpha: 0.5);
  margin-bottom: 30px;

  .date_special {
    .descript {
      margin: 5px 0;
      font-size: 12px;
    }

    input {
      border-radius: 5px;
      border: 1px dashed #ccc;
      // background: #ccc;
    }
  }

  .form_input {
    position: relative;
    flex-wrap: wrap;
    white-space: wrap;

    label {
      line-height: 21px;
      padding: 0 10px;
      flex: 2;
      font-weight: bold;
    }

    .descript_label {
      position: absolute;
      top: 35px;
      color: #fff;
      padding: 5px;
      font-size: 13px;
      border-radius: 3px;
      background: #666;
      z-index: 1;
    }

    .descript_icon {
      cursor: pointer;
    }

    >div {
      flex: 7;

      input,
      textarea {
        width: 100%;
      }
    }

    .img_upload {
      margin: 0px 0;

      // border-left: 3px solid var(--mainColor);
      // padding:10px 10px;
      img {
        max-width: 100%;
        border: 1px solid #ccc;
        margin: 10px 0 0 0;
      }

      label {
        font-size: 13px;
        border-radius: 5px;
        cursor: pointer;
        border: 1px dashed #ccc;
        display: block;
        text-align: center;
        padding: 10px 50px;
        color: #ccc;

        &:hover {
          border: 1px solid var(--mainColor);
          color: var(--mainColor);

          i {
            color: var(--mainColor);
          }
        }
      }

      >input {
        display: none;
      }

      .sub_block {
        margin: 15px 0 15px 5px;
        padding: 5px 10px;
        // border-radius: 5px;
        border-left: 3px solid var(--mainColor2);

        // background: #f1f1f1;
        .date_special {
          input {
            width: 220px;
            border: none;
            background: #e4e4e4 !important;
          }
        }

        .time {
          align-items: center;

          .el-input__inner:focus {
            border-color: var(--mainColor);
          }

          .time_el {
            margin-left: 10px;
          }

          input {
            background: transparent;
            // border: 1px solid #cab5ff;
            // color: #a17cff;
          }
        }

        .indent {
          margin: 0 0 10px 30px;
        }

        .descript {
          line-height: 20px;
        }
      }
    }

    .mark {
      color: #999;
      font-size: 13px;
      margin: 10px 0;
      display: block;
    }

    .must {
      color: var(--subColor);
    }
  }
}

.personal_data {
  margin-bottom: 30px;
}

.addEmployee_btn {
  justify-content: center;
  margin-bottom: 20px;

  >div {
    margin: 0 8px;
    min-width: 150px;
    max-width: 200px;
  }
}

// 隱藏el-date-picker的header中, 年份的前後按鈕
.picker-date {
  .el-date-picker__header {
    button:nth-child(1) {
      display: none;
    }

    button:nth-child(5) {
      display: none;
    }
  }
}
</style>
<script>
import * as moment from "moment";
export default {
  name: "addEmployee",
  data() {
    return {
      formInput: {
        license_factory: null,
        name: null,
        is_foreign: false,
        onboard_date: null,
        bloodtype: null,
        id_no: null,
        is_male: null,
        birth_date: null,
        email: null,
        address: null,
        cellphone: null,
        phone: null,
        is_engineer: null,
        is_resident: null,
        need_sheet: null,
        permission: true,
        status: true,
        leave_date: null,
        accident_insurance_expiry_date: null,
        training_expiry_date: null,
      },
      options: {
        license_factory: ["N6"],
        bloodtype: ["A", "B", "O", "AB"],
      },
      upImg: null,
      file: {
        labor: null,
        idCard: null,
        insurance: null,
        traning: null,
      },
      formData: new FormData(),
      formField: [
        {
          name: "領證廠區",
          val: "license_factory",
          type: "select",
          placeholder: "choose",
          must: true,
          rewrite: true,
          switchText: null,
        },
        {
          name: "姓名",
          val: "name",
          type: "input",
          placeholder: null,
          must: true,
          rewrite: true,
          switchText: null,
        },
        {
          name: "外國身份",
          val: "is_foreign",
          type: "switch",
          placeholder: "choose",
          must: true,
          rewrite: true,
          switchText: ["是", "否"],
        },
        {
          name: "身分證字號",
          val: "id_no",
          type: "input",
          placeholder: null,
          must: true,
          switchText: null,
          rewrite: false,
          descript: "如果為外國身份，請改輸入護照號碼，且新增後無法修改",
        },
        {
          name: "到職日期",
          val: "onboard_date",
          type: "date",
          placeholder: "年-月-日",
          switchText: null,
          rewrite: true,
          must: false,
        },
        {
          name: "血型",
          val: "bloodtype",
          type: "select",
          placeholder: "choose",
          switchText: null,
          rewrite: true,
          must: true,
        },
        {
          name: "性別",
          val: "is_male",
          type: "radio",
          placeholder: null,
          switchText: ["男", "女"],
          rewrite: true,
          must: false,
        },
        {
          name: "出生日",
          val: "birth_date",
          type: "date",
          placeholder: "年-月-日",
          switchText: null,
          rewrite: true,
          must: true,
        },
        {
          name: "電子信箱",
          val: "email",
          type: "input",
          placeholder: null,
          switchText: null,
          rewrite: true,
          must: false,
        },
        {
          name: "地址",
          val: "address",
          type: "input",
          placeholder: null,
          switchText: null,
          rewrite: true,
          must: true,
        },
        {
          name: "手機",
          val: "cellphone",
          type: "input",
          placeholder: null,
          switchText: null,
          rewrite: true,
          must: true,
        },
        {
          name: "電話",
          val: "phone",
          type: "input",
          placeholder: null,
          switchText: null,
          rewrite: true,
          must: false,
        },
        {
          name: "工程類別",
          val: "is_engineer",
          type: "radio",
          placeholder: null,
          rewrite: true,
          switchText: [
            "工程類(一般類)",
            "非工程類(免勞工安全衛生教育訓練證明)",
          ],
          must: true,
        },
        {
          name: "駐廠狀態",
          val: "is_resident",
          type: "radio",
          placeholder: null,
          rewrite: true,
          switchText: ["駐廠", "非駐廠"],
          must: true,
        },
        // {
        //   name: "進廠施工單",
        //   val: "need_sheet",
        //   type: "radio",
        //   placeholder: null,
        //   switchText: ["需要", "不需要"],
        //   must: false
        // },
        // {
        //   name: "進入權限",
        //   val: "permission",
        //   type: "switch",
        //   placeholder: null,
        //   switchText: ["正常", "停權"],
        //   must: true
        // },
        // {
        //   name: "狀態",
        //   val: "status",
        //   type: "switch",
        //   placeholder: null,
        //   rewrite: true,
        //   switchText: ["現職", "離職"],
        //   must: false,
        // },
        {
          name: "離職日期",
          val: "leave_date",
          type: "date",
          placeholder: "年-月-日",
          switchText: null,
          rewrite: true,
          must: false,
        },
      ],
      popupStatus: false,
      successText: null,
      popup: null,
      checkOK: [],
      checkID: false,
      descript: {
        show: false,
        index: null,
      },
      personal_data: true,
    };
  },
  computed: {
    role() {
      return this.$store.state.user.role;
    },
    storage() {
      return this.$http.base.storage;
    },
    employeeId() {
      return this.$route.query.employee_id;
    },
    vendorId() {
      return this.$store.state.user.id;
    },
    ButtonText() {
      if (this.employeeId) {
        return "修改";
      } else {
        return "新增";
      }
    },
    time() {
      return moment().format();
    },
  },
  methods: {
    getData() {
      //判斷身份，如果為工安，不能修改資料且要下載檔案
      if (this.role == "manager" || this.role == "department") {
        this.$http.api.vendor.vendorEmployeeGet(this.employeeId).then((res) => {
          for (let key in this.formInput) {
            this.formInput[key] = res.data[key];
            this.formField.forEach((el) => {
              el.type = "text";
            });
          }
          const num = Math.floor(Math.random() * 10);
          this.upImg = `${this.$http.base.storage}${res.data.photo}?v=${num}`;
          this.file.labor = res.data.labor_insurance;
          this.file.idCard = res.data.id_card;
          this.file.insurance = res.data.accident_insurance;
          this.file.traning = res.data.training;
        });
      } else if (this.role == "vendor") {
        this.$http.api.vendor.vendorEmployeeGet(this.employeeId).then((res) => {
          for (let key in this.formInput) {
            this.formInput[key] = res.data[key];
            this.formField.forEach((el) => {
              if (!el.rewrite && res.data[el.val]) {
                el.type = "text";
              }
            });
          }
          this.upImg = `${this.$http.base.storage}${res.data.photo}?${this.time}`;
          this.file.labor = res.data.labor_insurance;
          this.file.idCard = res.data.id_card;
          this.file.insurance = res.data.accident_insurance;
          this.file.traning = res.data.training;
        });
      }
    },
    photoUpload(event) {
      //預覽圖片
      let img = event.target.files[0];
      this.formData.append("photo", event.target.files[0]); //放進上傳的檔案
      let reader = new FileReader();
      reader.readAsDataURL(img);
      reader.addEventListener("load", this.imageLoader);
    },
    imageLoader(e) {
      this.upImg = `${e.target.result}`;
    },
    laborUpload(e) {
      this.file.labor = e.target.files[0].name;
      this.formData.append("labor_insurance", e.target.files[0]); //放進上傳的檔案
    },
    idCardUpload(e) {
      this.file.idCard = e.target.files[0].name;
      this.formData.append("id_card", e.target.files[0]); //放進上傳的檔案
    },
    insuranceUpload(e) {
      this.file.insurance = e.target.files[0].name;
      this.formData.append("accident_insurance", e.target.files[0]); //放進上傳的檔案
    },
    traningUpload(e) {
      this.file.traning = e.target.files[0].name;
      this.formData.append("training", e.target.files[0]); //放進上傳的檔案
    },
    cancelFile(file) {
      this.file[file] = null;
      this.formData.delete(file);
    },
    enter() {
      this.checkOK = [];
      //先判斷必填
      this.formField.forEach((el) => {
        if (
          el.must &&
          (this.formInput[el.val] == null || this.formInput[el.val].length == 0)
        ) {
          //必填且欄位沒有值
          this.checkOK.push(el.name);
        }
      });

      if (this.checkOK.length !== 0) {
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫:${this.checkOK.join()}`;
      }
      // 判斷文件
      if (!this.file.idCard && !this.file.labor && !this.upImg) {
        this.checkOK.push("file");
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請上傳必要文件`;
      }
      if (!this.personal_data) {
        this.checkOK.push("personal");
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請勾選個資法條件`;
      }

      if (this.checkOK.length == 0) {
        //必填完成
        //===============================
        //轉資料格式

        this.formData.append("form_input", JSON.stringify(this.formInput));
        //判斷是新增還是修改
        if (this.employeeId) {
          //修改
          this.$http.api.vendor
            .vendorEmployeePut(this.employeeId, this.formData)
            .then((res) => {
              this.popupStatus = true;
              this.successText = "成功";
              this.popup = "success";
              this.formData.delete("form_input");
            })
            .catch((error) => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "新增失敗";
              this.formData.delete("form_input");
              if (error.response.status == 401) {
                this.successText = "已經重複註冊";
              }
            });
        } else {
          //新增
          this.$http.api.vendor
            .vendorEmployeePost(this.vendorId, this.formData)
            .then((res) => {
              this.popupStatus = true;
              this.successText = "成功";
              this.popup = "success";
              this.formData.delete("form_input");
            })
            .catch((error) => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "新增失敗";
              this.formData.delete("form_input");
              if (error.response.status == 422) {
                this.successText = "已經重複註冊";
              }
            });
        }
      }
    },
    codeEnter() {
      this.$http.api.admin
        .makeCode(this.employeeId)
        .then((res) => {
          this.popupStatus = true;
          this.successText = "成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "核發失敗";
        });
    },
    returnBack() {
      this.$router.go(-1);
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        this.$router.go(-1);
      }
    },
    descriptShow(index) {
      this.descript.show = true;
      this.descript.index = index;
    },
    descriptHide() {
      this.descript.show = false;
      this.descript.index = null;
    },
  },
  watch: {
    formInput: {
      handler(newVal, oldVal) {
        if (newVal.id_no) {
          const id = newVal.id_no.toUpperCase();
          const rule = /^[A-Z]\d{9}/;
          //當身分證字號有值，但不符合格式，且不為外國人，會進入格式檢查。
          if (!id.match(rule) && !newVal.is_foreign) {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = "身分證格式輸入錯誤";
            this.checkID = false;
          } else {
            this.checkID = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.employeeId) {
      this.getData();
    }
  },
};
</script>
